import request from '@/libs/http/index'
// 登录
export const login = data => {
  return request.post({ url: '/system/auth/login', data })
}
// 手机号查询机构
export const getByUserName = data => {
  return request.get({
    url: `/system/auth/get-id-by-username?username=${data}`,
  })
}
// 获取验证码
export const sendSmsCode = data => {
  return request.post({
    url: `/system/auth/send-sms-code`,
    data,
  })
}
// 验证码登录
export const smsLogin = data => {
  return request.post({
    url: `/system/auth/sms-login`,
    data,
    noErrorTip: true,
  })
}
// 密码登录
export const passwordLogin = data => {
  return request.post({
    url: `/system/auth/login`,
    data,
    noErrorTip: true,
  })
}
// 设置密码
export const resetPassword = data => {
  return request.post({
    url: `/system/auth/reset-password`,
    data,
  })
}
// 获取二维码
export const getQrcode = data => {
  return request.get({
    url: `/system/social-client/get-login-qrcode`,
  })
}
// 扫码成功
export const getOpenId = data => {
  return request.get({
    url: `/system/auth/getOpenId?eventKey=${data}`,
  })
}
// 扫码状态
export const getSignStatus = params => {
  return request.get({
    url: `/system/auth/getSignStatus`,
    params,
    noErrorTip: true,
  })
}
// 获取门店列表
export const getDeptList = data => {
  return request.get({
    url: `/system/dept/tenant-dept-list`,
  })
}
// 申请试用
export const applyCreate = data => {
  return request.post({
    url: `/clinic/apply-try/create`,
    data,
  })
}
// 申请试用
export const logout = data => {
  return request.post({
    url: `/system/auth/logout`,
    data,
  })
}

// 获取用户信息
export const getPermissionInfo = params => {
  return request.get({
    url: `/system/auth/get-tenant-permission-info`,
    params,
  })
}
// 更换手机号
export const updateMobile = data => {
  return request.put({
    url: `/system/user/update-mobile`,
    data,
  })
}
// 校验验证码
export const validateSmsCode = data => {
  return request.post({
    url: `/system/user/validate-sms-code`,
    data,
  })
}

// 获取套餐详情
export const getPackageDetail = params => {
  return request.get({
    url: `/system/tenant-package/get`,
    params,
  })
}
// 获取套餐分页
export const getPackagePage = params => {
  return request.get({
    url: `/system/tenant-package/page`,
    params,
  })
}
// 获取账户详情
export const getTransferDetail = params => {
  return request.get({
    url: `/clinic/corporate-transfer/get`,
    params,
  })
}
// 付费功能列表
export const getPaidFeaturePage = params => {
  return request.get({
    url: `/clinic/paid-feature/page`,
    params,
  })
}
// 获取已购买功能列表
export const getDirectories = params => {
  return request.get({
    url: `/clinic/paid-feature-tenant/get-directories`,
    params,
  })
}
// 获取顾问信息
export const getConsultant = params => {
  return request.get({
    url: `/system/auth/get-consultant-info`,
    params,
  })
}
// 获取最新版本
export const getFirstAppVersion = (params: { type: number }) => {
  return request.get({
    url: `/clinic/app-version/get-first-version`,
    params,
    noErrorTip: true,
  })
}
